var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-wrapper__body"},[_c('aside',{ref:"shortlinks",staticClass:"shortlinks"},[_vm._m(0),_vm._t("social-media")],2),_c('article',{staticClass:"editor-component"},[_vm._t("editor-component")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"shortlinks__sidebar",attrs:{"role":"navigation","aria-label":"Table of contents"}},[_c('ul',{attrs:{"id":"shortlinks"}})])
}]

export { render, staticRenderFns }